import React, { Component, Fragment } from 'react';
import { withApi } from '../Providers/WebServiceProvider.js';
import MasterStringsService from '../Services/MasterStringsService.js';
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { Prompt, withRouter } from 'react-router';
import Swal from 'sweetalert2';

class MasterFileComparator extends Component {
  constructor (props) {
    super(props);

    this.state = {
      exceptions: [],
      isBusy: false
    };
 
    this.toggleException = this.toggleException.bind(this);
    this.applyMasterChanges = this.applyMasterChanges.bind(this);
    this.uploader = new MasterStringsService(props.webServiceContext.getApi());
  }

  toggleException (key) {
    if (this.state.exceptions.indexOf(key) <= -1) {
      this.setState(prevState => ({ exceptions: prevState.exceptions.concat(key) }));
    } else {
      this.setState(prevState => ({ exceptions: prevState.exceptions.filter(item => item !== key) }));  
    }
  }

  anyDifferencesAvailable () {
    const that = this;
    let anyAvailable = false;

    Object.keys(this.props.differences).forEach(function (key) {
      if (that.props.differences[key].old === null) {
        that.props.differences[key].old = "";
      }
      if (that.props.differences[key].new === null) {
        that.props.differences[key].new = "";
      }
      if (that.props.differences[key].old.trim() !== that.props.differences[key].new.trim() && that.props.differences[key].old.trim() !== null) {
        anyAvailable = true;
      }
    })

    return anyAvailable;
  }

  applyMasterChanges () {
    const that = this;

    Swal("", 'Applying changes...', 'info');

    this.uploader.apply(this.props.differences, this.state.exceptions).then(function () {
      that.setState({ isBusy: false });

      Swal('Yes!', 'Master file successfully uploaded. Refreshing in 3 seconds...', 'success');

      setTimeout(() => { window.location.reload() }, 3000);
    })
  }

  render () {
    const that = this, applyChangesButton = (
      <button type="button" className="button is-primary is-gradient" disabled={this.state.isBusy} onClick={this.applyMasterChanges}>Apply Changes</button>
    );

    if (!this.anyDifferencesAvailable()) {
      return (
        <Fragment>
          <Prompt 
            message={"You have unsaved changes on this page. Do you want to leave this page and discard your changes or stay on this page?"}
          />
          <div className="master-differences">
            <div className="info">
              <span className="icon"><FontAwesomeIcon icon="check-circle" color="#007e91" fixedWidth /></span>
              <span className="text">No differences found!</span>
              <span className="sub-text">It could be the first master upload, or there are simply no differences.</span>
            </div>
            <div className="actions">
              {applyChangesButton}
            </div>
          </div>
        </Fragment>
      );
    } else {
      const strings = Object.keys(this.props.differences)
        .filter(difference => (this.props.differences[difference].old.trim() !== this.props.differences[difference].new.trim()))
        .map(function (difference) {
          return (
            <div className="string" key={difference}>
              <span className="attribute old">
                {that.props.differences[difference].old === "" ? "NOT PRESENT" : that.props.differences[difference].old}
              </span>
              <span className="attribute arrow"><FontAwesomeIcon icon="forward" color="black" /></span>
              <span className="attribute diff">
                {that.props.differences[difference].new === "" ? "DELETED" : that.props.differences[difference].new}
              </span>
              <span className="attribute action">
                <input type="checkbox" onChange={(e) => that.toggleException(difference)} />
              </span>
            </div>
          );
        }
      );

      return (
        <Fragment>
          <Prompt 
            message={"You have unsaved changes on this page. Do you want to leave this page and discard your changes or stay on this page?"}
          />
          <div className="master-differences">
            <div className="info">
              <span className="icon"><FontAwesomeIcon icon="exclamation-triangle" color="#fbd5d5" fixedWidth /></span>
              <span className="text">Differences found!</span>
              <span className="sub-text">Check the found differences and select which ones to exclude from de-validation.</span>
            </div>
            <div className="strings">
              {strings}
            </div>
            <div className="actions">
              {applyChangesButton}
            </div>
          </div>
        </Fragment>
      );
    }

    return ('comparator yo');
  }
}

export default withApi(withRouter(MasterFileComparator));


// WEBPACK FOOTER //
// ./src/Components/MasterFileComparator.js